import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PartySurveysPageState = {
  partySurveys: {
    data: [],
    loading: false,
    error: null,
    currentCard: 0,
    cards: [],
  },
}

export const PartySurveysPageActions = {
  fetchPartySurveys: async ({ commit }) => {
    commit('setPartySurveyLoading', true)

    return axiosRequest.get('/party_surveys').
      then(({ data }) => {
        commit('setPartySurveys', data)
        commit('setPartySurveyLoading', false)
      }).
      catch(handleError)
  },

  fetchSurveyParty: async ({ commit }, session) => {
    return axiosRequest.
      get(`/survey/${session}/party`).
      then(({ data }) => {
        commit('surveyPageSetSessionParty', data)
      })
  },

  surveyPartyLoadSession: async ({ commit }, session) => {
    return axiosRequest.
      get(`/survey/${session}`).
      then(({ data }) => {
        commit('surveyPageSetSession', data)
      }).
      catch(handleError)
  },

  surveyPartySaveSession: async ({ state }) => {
    return axiosRequest.
      patch(`/survey/${state.survey_session.auth_token}`, state.survey_session).
      catch(handleError)
  },

  surveyPartyNextCard: ({ state, commit, dispatch, getters }) => {
    const cards = getters.partySurveySessionCards

    commit('surveyPageSetCurrentDone')
    if (state.partySurveys.currentCard < cards.length - 1) {
      commit('surveyPageSetCurrentCard', state.partySurveys.currentCard + 1)
    } else {
      commit('surveyPageSetCurrentCard', 'completed')
    }
    dispatch('surveyPartySaveSession')
  },

  surveyPartyPreviousCard: ({ state, commit }) => {
    if (state.partySurveys.currentCard === 0) return
    commit('surveyPageSetCurrentCard', state.partySurveys.currentCard - 1)
  },

  surveyPageSetCurrentCard: ({ commit, dispatch }, value) => {
    commit('surveyPageSetCurrentCard', value)
    dispatch('surveyPartySaveSession')
  },

  surveyPartyDuplicateCurrentCard: ({ commit, getters, dispatch, state }) => {
    const currentCard = getters.partySurveyCurrentCardData
    const currentCardIndex = getters.partySurveyCurrentCard

    const newCard = JSON.parse(JSON.stringify(currentCard))
    newCard.identifier = `${currentCard.identifier}_${state.survey_session.value.length + 1}`
    for (const field of Object.keys(newCard.inputs)) {
      newCard.inputs[field] = null
    }

    commit('surveyPageInsertCard', { card: newCard, index: currentCardIndex })
    dispatch('surveyPartyNextCard')
  },

  surveyPartySubmitSession: async ({ state, commit }) => {
    return axiosRequest.
      post(`/survey/${state.survey_session.auth_token}`, state.survey_session).
      then(({ data }) => { commit('surveyPageSetSession', data) }).
      catch(handleError)
  },
}

export const PartySurveysPageGetters = {
  partySurveys: state => state.partySurveys.data || [],
  partySurveySessionData: state => state.survey_session || {},
  partySurveySessionParty: state => state.survey_party || {},
  partySurveySessionCards: state => state.survey_session?.value || [],
  partySurveyCurrentCard: state => state.partySurveys.currentCard,
  partySurveyCurrentCardData: state => {
    return state.survey_session?.value[state.partySurveys.currentCard]
  },
  partySurveyCardsByIdentifiers: state => identifier => {
    const cards = state.survey_session?.submissions_by_identifiers[identifier] || []
    // Filter out cards that have been accepted and now exist as real records
    // Check if the card has been marked as accepted in survey session
    return cards.filter(card => {
      const sessionCard = state.survey_session?.value?.find(c => c.identifier === card.identifier)
      return !sessionCard?.accepted
    })
  },
}

export const PartySurveysPageMutations = {
  setPartySurveys: (state, payload) => {
    state.partySurveys.data = payload || []
  },
  setPartySurveyLoading: (state, payload) => {
    state.partySurveys.loading = payload
  },
  surveyPageSetSession: (state, session) => Vue.set(state, 'survey_session', session),
  surveyPageSetCurrentCard: (state, card) => { state.partySurveys.currentCard = card },
  surveyPageSetCards: (state, cards) => Vue.set(state.partySurveys, 'cards', cards),
  surveyPageSetCurrentDone: state => {
    const card = state.survey_session?.value[state.partySurveys.currentCard]
    card.completed = true
  },

  surveyPageInsertCard: (state, { card, index }) => {
    state.survey_session?.value.splice(index + 1, 0, card)
  },
}
